export default __webpack_public_path__ + "assets/images/c77c388a788b3f2a8be7fa5388be4c9d.svg";